import UserInformation from "../../types/UserInformation";

export const loggerUserReducer = (
  state = null,
  action: any
): UserInformation | null => {
  switch (action.type) {
    case 'LOGGING_USER':
      return {
        id: action?.payload?.id,
        name: action?.payload?.name,
        prenom: action?.payload?.prenom,
        email: action?.payload?.email,
        Departement: action?.payload?.Departement,
        profils: action?.payload?.profils,
        pays: action?.payload?.pays,
        features: action?.payload?.features,
        updated_password: action?.payload?.updated_password,
        password_expired: action?.payload?.password_expired,
        token: action?.payload?.token
      };
    case 'LOGGOUT_USER':
      return null;
    default:
      return state;
  }
};
